import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { m } from "framer-motion";
import { Helmet } from "react-helmet-async";

const DakujemeAI = () => {
  const [hasTracked, setHasTracked] = useState(false);

  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);

    // Track pageview
    if (!hasTracked && window.dataLayer) {
      window.dataLayer.push({
        event: "virtualPageview",
        pagePath: "/dakujeme-ai",
        pageTitle: "Thank You - AI Audit Form",
      });
      setHasTracked(true);
    }
  }, [hasTracked]);

  return (
    <>
      <Helmet>
        <title>Ďakujeme za váš záujem o AI audit | INAQ</title>
        <meta
          name="description"
          content="Ďakujeme za váš záujem o AI audit. Čoskoro sa vám ozveme."
        />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 to-purple-50 px-4 pt-[80px]">
        <m.div
          className="max-w-[640px] w-full bg-white rounded-lg shadow-xl p-12 sm:p-8 text-center"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <img
              src="/assets/img/iq_tick.gif"
              alt="Success"
              className="w-20 h-20"
            />
          </div>

          {/* Heading */}
          <h1 className="font-[Oxanium] text-4xl sm:text-3xl text-inaqpurple font-bold mb-4">
            Ďakujeme za váš záujem o AI audit!
          </h1>

          {/* Message */}
          <p className="font-rubik text-lg sm:text-base text-gray-700 mb-8 leading-relaxed">
            Vašu požiadavku sme úspešne prijali. Naši AI experti ju čoskoro preskúmajú
            a ozvú sa vám s prvými poznatkami.
          </p>

          {/* Divider */}
          <div className="border-t border-gray-200 my-8"></div>

          {/* Additional Content */}
          <div className="mb-8">
            <h2 className="font-[Oxanium] text-xl text-inaqpurple font-medium mb-4">
              Čo môžete očakávať
            </h2>
            <ul className="font-rubik text-sm text-gray-600 mb-6 text-left space-y-2">
              <li className="flex items-start gap-2">
                <span className="text-inaqgold">✓</span>
                Analýzu vašich procesov do 24 hodín
              </li>
              <li className="flex items-start gap-2">
                <span className="text-inaqgold">✓</span>
                Identifikáciu príležitostí pre AI a automatizáciu
              </li>
              <li className="flex items-start gap-2">
                <span className="text-inaqgold">✓</span>
                Osobnú konzultáciu s našim tímom
              </li>
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link
              to="/"
              className="w-full sm:w-auto px-8 py-3 bg-inaqgold text-white font-rubik font-medium rounded-sm hover:bg-opacity-90 transition-all duration-300 text-center"
            >
              Späť na homepage
            </Link>
            <Link
              to="/blog"
              className="w-full sm:w-auto px-8 py-3 border-2 border-inaqgold text-inaqgold font-rubik font-medium rounded-sm hover:bg-inaqgold hover:text-white transition-all duration-300 text-center"
            >
              Prejsť na blog
            </Link>
          </div>

          {/* Footer Note */}
          <p className="font-rubik text-xs text-gray-500 mt-8">
            V prípade naliehavých otázok nás môžete kontaktovať na{" "}
            <a
              href="mailto:ai@inaq.sk"
              className="text-inaqgold hover:underline"
            >
              ai@inaq.sk
            </a>
          </p>
        </m.div>
      </div>
    </>
  );
};

export default DakujemeAI;
